declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, StoreLocationMaterialsRequest, StoreLocationMaterialsController, MaterialBatchInaStoreController, DoctorsListController, DoctorsListRequest, MaterialsListController, MaterialsListRequest, SavePurchaseOrderRequest, S_Methods, PurchaseIndentItemsController, PurchaseIndentItemsRequest, PurchaseIndentItemsInfoController, PurchaseIndentsListController, PurchaseOrderItemRequest, PurchaseOrderDetailsInfoController, PurchaseOrdersListController, VendorsListController, SaveDoccumentStateRequest, GenericProcPostRequest, CustomCodeValuesController } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbBatchDetail2Modal } from '../consumptionentry/batchdetail2.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
import { NgbGoodsInvoiceModal } from './modal/goodsinvoice.modal';
import { NgbSearchVendorsModal } from './modal/searchvendors.modal';
import { NgbEditPOitemsModal } from './modal/editPOitems.modal';
import { NgbEditPOVIitemsModal } from './modal/editPOVIitems.modal';
const isNullOrUndefined = (val: any) => val === null || val === undefined;





@Component({
  selector: 'poviadd',
  templateUrl: './poviadd.component.html',
  styleUrls: ['./poviadd.component.scss']
  , animations: [routerTransition()]
})

export class POVIAddComponent implements OnInit {


  public ApiResData: ApiResponseModel;

  public ActorCode: number = 0;
  public ShowList: boolean = true;
  public ShowPatientDetails: boolean = false;
    public searchValue: string;
  public isvisible: boolean = true;
  public BranchName: string;
  public Date: Date;
  public ActorCode2: number;
  public FacilityCode: number;
  public DocIDdata: string;
  public VendorCode: any;
  public VendorName: any;
  public VendorContact: any;
  public UnitPrice: number;
  public TaxPercent: number;
  public ItemTax: number;
  public Quantity: number;
  public BonusQuantity: number = 0;
  public TotalOrderQuantity: number;
  public UomName: string;
  public Mrp: number;
  public Pack: number;
  public PurchasePrice: number;
  public SalePrice: number;
  public Location: string;
  public RequestedBy: string;
  public TermsAndConditions: string = "";
  searchTitle: string;
  isRequesting: boolean;
    MfgDate: NgbDateStruct;
  ExpDate: NgbDateStruct;
  PostingDate: NgbDateStruct;
  DeliveryDate: NgbDateStruct;
  public DefaultExpDate: NgbDateStruct;
  TodayDate = new Date();

  CurrentStoreLocationMaterialsRequest: StoreLocationMaterialsRequest;
  CurrentStoreLocationMaterialsController: StoreLocationMaterialsController[];
  StoreItems() {
    // alert()
    this.CurrentStoreLocationMaterialsRequest = new StoreLocationMaterialsRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;

    this.CurrentStoreLocationMaterialsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentStoreLocationMaterialsRequest.ConditionalOperator = 10;
    this.CurrentStoreLocationMaterialsRequest.StoreCode = this.StoreCode;
    this.pdata = this.CurrentStoreLocationMaterialsController;

    this.GetStoreLocationMaterialsController();

  }
  GetStoreLocationMaterialsController() {
    this.StartRefreshing();
    this.spinner.show();
    this.actorservice.GetStoreLocationMaterialsController(this.CurrentStoreLocationMaterialsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentStoreLocationMaterialsController = this.ApiResData.Result;
          this.pdata = this.CurrentStoreLocationMaterialsController;
          this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  CurrentMaterialsListRequest: MaterialsListRequest;
  CurrentMaterialsListController: MaterialsListController[];
  StoreItems2() {
    this.CurrentMaterialsListRequest = new MaterialsListRequest();
    this.CurrentMaterialsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentMaterialsListRequest.ConditionalOperator = 10;
    this.CurrentMaterialsListRequest.MaterialCode = 0;
    this.GetMaterialsListController();
  }
  RefreshPatients(st: string) {
    this.CurrentMaterialsListRequest = new MaterialsListRequest();
    this.CurrentMaterialsListRequest.ConditionalOperator = 20;
    this.CurrentMaterialsListRequest.SearchText = st;
    this.CurrentMaterialsListRequest.MaterialCode = 0;
    this.CurrentMaterialsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetMaterialsListController();
  }
  GetMaterialsListController() {
    this.StartRefreshing();
    this.actorservice.GetMaterialsListController(this.CurrentMaterialsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentMaterialsListController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }
      );
  }
  //criteriaChange(value: string) {
  //  this.RefreshPatients(value);
  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentStoreLocationMaterialsController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentStoreLocationMaterialsController,
          this.listFilter);
      }
    }
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {
    this.StoreCode = AppData.Instance().cas.RxDefault_StoreCode;
    this.CurrentSavePurchaseOrderRequest = new SavePurchaseOrderRequest();
    this.CurrentSavePurchaseOrderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.StoreItems();
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
    this.Location = AppData.Instance().SelectedBranchName;
    this.RequestedBy = AppData.Instance().UserLoginDetails.UserName;
    this.TermsAndConditions = AppData.Instance().cas.Terms_Conditions;
    this.PostingDate = {
      year: this.TodayDate.getFullYear(),
      month: this.TodayDate.getMonth() + 1,
      day: this.TodayDate.getDate()
    };
    this.DeliveryDate = {
      year: this.TodayDate.getFullYear(),
      month: this.TodayDate.getMonth() + 1,
      day: this.TodayDate.getDate() + 15
    };
    this.DefaultExpDate = {
      year: this.TodayDate.getFullYear(),
      month: this.TodayDate.getMonth() + 1,
      day: this.TodayDate.getDate()
    };
      
  }

  ClearInput() {
    this.searchValue = '';
    this.RefreshPatients(this.searchValue);
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  CurrentSavePurchaseOrderRequest: SavePurchaseOrderRequest;
  PurchaseOrderData: SavePurchaseOrderRequest;
  CurrentPurchaseOrderData: Array<PurchaseOrderItemRequest>;
  AddRow(l: StoreLocationMaterialsController) {
    //this.CurrentPurchaseOrderData = new Array<PurchaseOrderItemRequest>();
    if (this.CurrentPurchaseOrderData == null) {
      this.CurrentPurchaseOrderData = new Array<PurchaseOrderItemRequest>();
    }
    var itemExists = this.CurrentPurchaseOrderData.find(x => x.ItemCode == l.MaterialSpec);
    if (itemExists != null) {
      return;
    }
    else {
      var row = new PurchaseOrderItemRequest();
      row.ItemCode = l.MaterialSpec;
      row.ItemDescription = l.Description;
      row.Material = l.Material;
      row.MaterialGroup = l.MaterialGroup;
      row.PurchaseOrderItemCode = 0;
      row.Quantity = 1;
      row.UomName = l.SaleUOM;
      row.UnitPrice = this.UnitPrice;
      row.TaxPercent = this.TaxPercent;
      row.Tax = this.ItemTax;
      row.BonusQuantity = this.BonusQuantity;
      row.TotalOrderQuantity = this.TotalOrderQuantity;
      row.Mrp = this.Mrp;
      row.Pack = this.Pack;
      row.PurchasePrice = this.PurchasePrice;
      row.SalePrice = this.SalePrice;
      row.ExpiryDate = new Date(this.parserFormatter.format(this.DefaultExpDate));

      this.CurrentPurchaseOrderData.push(row);
    }

  }
  SaveData() {
    var saveReq = new SavePurchaseOrderRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40320;
    saveReq.OwnerName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.OwnerLocation = AppData.Instance().SelectedBranchCode;
    saveReq.PostingDate = new Date(this.parserFormatter.format(this.PostingDate));
    saveReq.DeliveryDate = new Date(this.parserFormatter.format(this.DeliveryDate));
    saveReq.SupplierCode = this.VendorCode;
    saveReq.SupplierName = this.VendorName;
    saveReq.SupplierContactPersonCode = this.VendorContact;
    //saveReq.RefDetails = this.PurchaseOrderData.RefDetails;
    //saveReq.PurchaseOrderCode = this.PurchaseOrderData.PurchaseOrderCode;
    //saveReq.OrderStatus = this.PurchaseOrderData.OrderStatus;
    //saveReq.PayInDays = this.PurchaseOrderData.PayInDays;
    saveReq.PayAgainst = 'GRN';
    //saveReq.PayAgainst = this.PurchaseOrderData.PayAgainst;
    saveReq.ShipToLocation = this.StoreCode2;
    saveReq.Items = this.CurrentPurchaseOrderData;
    saveReq.Tax = this.CurrentSavePurchaseOrderRequest.Tax;
    saveReq.TotalBeforeTax = this.CurrentSavePurchaseOrderRequest.TotalBeforeTax;
    saveReq.GrandTotal = this.CurrentSavePurchaseOrderRequest.GrandTotal;
    saveReq.Terms = this.TermsAndConditions;
    //saveReq.IndentFormattedCode = this.PurchaseOrderData.IndentFormattedCode;

    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40320;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
       // alert(result);
        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
        //this.ApiResData = result;
        //if (result.Result > 0) {
        //  this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
        //  this.stopRefreshing();
        //  this.spinner.hide();
        //  this.isvisible = false;
        //  this.router.navigate(['healins/povi']);
        //}
        //else {
        //  alertFunctions.AlertParam("Invalid Operation :- " + "...!");
        //  this.stopRefreshing();
        //  this.spinner.hide();
        //}
      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            //alertFunctions.AlertParamEr(error);
                    this.stopRefreshing();
          this.spinner.hide();
          this.isvisible = false;
          this.router.navigate(['healins/povi']);
        //    this.stopRefreshing();
          }
        }
      );
  }

  public istextshow: boolean = false;

  Cancel() {
    this.router.navigate(['healins/povi']);
  }
  opbill() {

  }
  SelectVendor() {
    const modalRef = this.modalService.open(NgbSearchVendorsModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((l: VendorsListController) => {      
      this.VendorCode = l.VendorCode;
      this.VendorName = l.DisplayName;
      this.VendorContact = l.Telephone1;
    });
  }
  EditItems(input: PurchaseOrderItemRequest) {
    const modalRef = this.modalService.open(NgbEditPOVIitemsModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.FromScreen = 'POVI';
    modalRef.componentInstance.PurchaseOrderItem = input;
    //modalRef.componentInstance.PurchaseOrderData = PurchaseOrderData;
    modalRef.componentInstance.VendorName = this.VendorName;
    modalRef.componentInstance.VendorCode = this.VendorCode;
    modalRef.result.then((l: PurchaseOrderItemRequest) => {
      input.UnitPrice = (l.PurchasePrice) / (l.Quantity * l.Pack);
      input.TotalOrderQuantity = l.Quantity + l.BonusQuantity;
      input.BonusQuantity = l.BonusQuantity;
      input.TaxPercent = l.TaxPercent;      
      input.Quantity = l.Quantity;
      //input.Discount = l.Discount;
      input.UomName = l.UomName;
      input.Mrp = l.Mrp;
      input.Pack = l.Pack;
      input.PurchasePrice = l.PurchasePrice;
      input.BatchNo = l.BatchNo;
      input.ExpiryDate = l.ExpiryDate;
      input.Tax = (l.Quantity * l.PurchasePrice * l.TaxPercent) / 100;
      input.ItemTotal = l.Quantity * l.PurchasePrice;
      input.ItemNet = input.ItemTotal + input.Tax;
      input.DiscountPercent = l.DiscountPercent;
      input.Discount = ((l.Quantity) * l.PurchasePrice * l.DiscountPercent) / 100;
      this.CalculateTotals();
    });
  }
  CalculateTotals() {
    //alert(this.CurrentOrderDetails.length);
    this.CurrentSavePurchaseOrderRequest.Tax = this.CurrentPurchaseOrderData.filter((item) => item.Tax)
      .map((item) => +item.Tax)
      .reduce((sum, current) => sum + current);

    this.CurrentSavePurchaseOrderRequest.TotalBeforeTax = this.CurrentPurchaseOrderData.filter((item) => item.PurchasePrice)
      .map((item) => item.Quantity * item.PurchasePrice)
      .reduce((sum, current) => sum + current);//-- * this.PurchaseOrderData.Items.filter((item) => item.Quantity)
      //.map((item) => +item.Quantity)
      //  .reduce((sum, current) => sum + current);
    this.CurrentSavePurchaseOrderRequest.GrandTotal = this.CurrentSavePurchaseOrderRequest.TotalBeforeTax + this.CurrentSavePurchaseOrderRequest.Tax;
    this.CurrentSavePurchaseOrderRequest.DiscountAmount = this.CurrentPurchaseOrderData.filter((item) => item.Discount)
      .map((item) => +item.Discount)
      .reduce((sum, current) => sum + current);

}
  StoreCode2: number = 0;
  public StoreName2: string;
  onAssignedToActorCodesurgeon2(event: any) {
    if (event != null) {
      this.StoreName2 = event;
      //this.StoreItems();
    }
  }
  StoreList_loaded(e: any) {

  }
  StoreCode: number = 0;
  public StoreName: string;
  onAssignedToActorCodesurgeon(event: any) {

    if (event != null) {
      this.StoreName = event;
      this.StoreItems();
    }
  }
  accessibleStores: CustomCodeValuesController[];
  loaded_data(e: any) {
    this.accessibleStores = e as CustomCodeValuesController[];
    var x = this.accessibleStores.find(x => x.Code == this.StoreCode);
    if (!isNullOrUndefined(x)) {
      this.StoreItems();
    }
  }

}


